export default __webpack_public_path__ + "static/media/P10002.331c322b.png";